export default __webpack_public_path__ + "static/media/43_mobile.8fdb40c1.jpg";